export default __webpack_public_path__ + "media/images/react_icons/paint-tool-grey-0e77449159469e0cc23163bd00e3131e.svg";